// Constantes produit du radar de profondeur (ticket #193).
// Poids : expérience validée = 1, non validée = 0,5, d'où
// w = validated_count × 1 + (count − validated_count) × 0,5 = (count + validated_count) / 2.
// La cible et la courbe vivent ici (côté front) pour être ajustables sans redéploiement API.
export const RADAR_DEPTH_TARGET = 5;

export interface RadarDepthCounts {
  count: number;
  validated_count: number;
}

export function radarWeightedCount({ count, validated_count }: RadarDepthCounts): number {
  return (count + validated_count) / 2;
}

// Valeur d'axe = min(100, 100 × √(w / cible)) : courbe saturante, un profil léger
// reste visible (1 exp non validée ≈ 32) sans rivaliser avec un expert (≥ 5 pondérées = 100).
export function radarDepthValue(counts: RadarDepthCounts): number {
  const w = radarWeightedCount(counts);
  if (w <= 0) return 0;
  return Math.min(100, Math.round(100 * Math.sqrt(w / RADAR_DEPTH_TARGET)));
}
